import { Component, OnInit } from '@angular/core';
import { ClaimRow } from '../../../../models/api/view/claim-view/claim-row';
import { BaseComponent } from '../../../base/base.component';
import { FileUploadComponent } from '../../../core/controls/file-upload.component';
import { PageHeaderComponent } from '../../../core/labels/page-header.component';

@Component({
  selector: 'app-upload-documents',
  imports: [PageHeaderComponent, FileUploadComponent],
  template: `
    <app-page-header
      label="Upload Documents"
      backRouterLink="../documents"
      backLabel="documents"
    ></app-page-header>
    <div class="tw-w-full">
      Please upload your file below. Up to {{ maxFiles }} can be selected. Size
      limits is {{ maxMediaSize }}MB per media file and {{ maxDocSize }}MB per
      document file.
    </div>
    <div class="tw-w-full">
      The following media file formats are supported: {{ supportedMedia }}.
    </div>
    <div class="tw-w-full">
      The following document file formats are supported: {{ supportedDocs }}.
    </div>
    <div class="tw-w-full tw-mb-4">
      Do not upload password protected documents as Sedgwick will not be able to
      open them.
    </div>
    <div class="tw-flex tw-mt-3">
      <app-file-upload
        class="tw-w-full sm:tw-w-2/3"
        [control]=""
        mode="advanced"
        [maxFiles]="maxFiles"
        [claim]="claim"
      ></app-file-upload>
    </div>
  `,
  styles: ``,
})
export class UploadDocumentsComponent extends BaseComponent implements OnInit {
  supportedFileTypes = '';

  claim: ClaimRow;

  maxFiles = 10;

  maxMediaSize = 750;

  maxDocSize = 6;

  supportedMedia =
    'mpeg, mp3, mp4, wmv, wav, avi, mkv, mov, m4v, dxa, mpg4, asf';

  supportedDocs = 'doc, gif, jpg, jpeg, pdf, rtf, tif, txt, png, docx';

  ngOnInit(): void {
    this.claim = this.view.currentClaim();
  }
}
